import { useEffect } from "react";
/**
 * Custom hook to lock/unlock body scroll when a component is active
 * Useful for modals, drawers, and other overlay components
 *
 * @param isActive - Boolean indicating whether the scroll should be locked
 *
 * @example
 * ```tsx
 * const MyDrawer = ({ isOpen }) => {
 *   useBodyScrollLock(isOpen);
 *   return <div>...</div>;
 * };
 * ```
 */
export const useBodyScrollLock = (isActive) => {
    useEffect(() => {
        // Hide main page scrollbar when active
        if (isActive) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        }
        return () => {
            // Cleanup: only reset overflow when not active
            if (!isActive) {
                document.body.style.overflow = "";
                document.documentElement.style.overflow = "";
            }
        };
    }, [isActive]);
};
